exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.privacy-modal[data-v-1cecfa5e] {\n  background-color: rgb(248, 230, 208) !important;\n}\n", ""]);

// exports
